module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "prologue"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Thou shalt not bear false witness")])]), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("I know that time is precious, but I have plenty of it for the foreseeable future. I will endeavour however, not to waste yours. There is not much to do here, so I finally have a chance to write a book – something I always thought I would get around to, but in much more pleasant circumstances than I find myself in currently.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("I have no laptop to work on, so I’m hoping I will be able to get hold of pen and paper at least. They say the pen is mightier than the sword, but right now I am not so sure about that.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("Anyway, it’s lights out soon, so I’ll let you and the judicial system (and possibly God) be the judge of who’s the real villain here.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("E")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("PS")])]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("My cellmate is already getting on my nerves, just what I need another annoying woman in my life!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec7193a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0